import { logAndylitics, log, logAPI } from "./andyliticsApi";
import * as tools from "../helpers/Tools";

const BASE_URL = typeof window !== 'undefined' ? window.serverData.data.phyndApibaseUrl : '';
const CLIENT_ID = "MyBSWHealth.Web";

export const getCityOrZip = (searchModel, timestamp) => {
    const fullUrl = `${BASE_URL}V2/Typeahead/GetAllMatchingCitiesOrZipCodes?filter=${encodeURIComponent(searchModel.filter)}&maxresults=${searchModel.maxResults ? searchModel.maxResults : "25"}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    
    var start = new Date();
    return fetch(fullUrl, params)
        .then(response => {
            return response.json();
        })
        .then(json => {
            return { timestamp: timestamp, results: json };
        })
        .catch(err => { logAPI("MBHWeb.Api.Typeahead.CityOrZip.Failure", new Date(), fullUrl, err); return Promise.reject(err); });
};

export const getMatchingTerms = (searchModel, timestamp) => {
    let fullUrl = `${BASE_URL}V2/Typeahead/GetAllMatchingTerms?term=${encodeURIComponent(searchModel.term)}`;
    
    fullUrl += searchModel.returnAll ? `&returnAll=${searchModel.returnAll}` : "&returnAll=false";
    fullUrl += searchModel.networkCode ? `&networkCode=${searchModel.networkCode}` : "";
    fullUrl += searchModel.acoAlliance ? `&acoAlliance=${searchModel.acoAlliance}` : "";
    fullUrl += searchModel.practiceGroup ? `&practiceGroup=${searchModel.practiceGroup}` : "&practiceGroup=BSW";
    fullUrl += searchModel.sortCategories ? `&sortCategories=${searchModel.sortCategories}` : "&sortCategories=true";

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    
    var start = new Date();
    return fetch(fullUrl, params)
        .then(response => {
            return response.json();
        })
        .then(json => {
            return { timestamp: timestamp, results: json };
        })
        .catch(err => {
            logAPI("MBHWeb.Api.Typeahead.MatchingTerms.Failure", new Date(), fullUrl, err);
            return Promise.reject(err);
        });
};

export const getMatchingTermsByLocation = (searchModel) => {
    let fullUrl = `${BASE_URL}V2/Typeahead/GetAllMatchingByLocation?term=${encodeURIComponent(searchModel.term)}`;

    fullUrl += searchModel.location ? `&location=${searchModel.location}` : "";
    fullUrl += searchModel.distance ? `&distance=${searchModel.distance}` : "";
    fullUrl += searchModel.returnAll ? `&returnAll=${searchModel.returnAll}` : "";
    fullUrl += searchModel.returnSpecialties ? `&returnSpecialties=${ searchModel.returnSpecialties }` : "";
    
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    
    var start = new Date();
    return fetch(fullUrl, params).then(response => {
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Typeahead.MatchingTermsByLocation.Failure", new Date(), fullUrl, err); return Promise.reject(err); });
};

export const getMatchingSpecialties = (searchModel) => {
    const fullUrl = `${BASE_URL}V2/Typeahead/GetMatchingSpecialties?term=${encodeURIComponent(searchModel.term)}`;
    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    
    var start = new Date();
    return fetch(fullUrl, params).then(response => {
        return response.json();
    }).catch(err => { logAPI("MBHWeb.Api.Typeahead.MatchingSpecialties.Failure", new Date(), fullUrl, err); return Promise.reject(err); });
};

export const getMatchingInsurance = (searchModel, timestamp) => {
    let fullUrl = `${BASE_URL}V2/Typeahead/GetAllMatchingInsurance?term=${encodeURIComponent(searchModel.term)}&groupByCarrier=true`;

    fullUrl += searchModel.returnAll ? `&returnAll=${searchModel.returnAll}` : "";
    fullUrl += searchModel.networkCode ? `&networkCode=${searchModel.networkCode}` : "";
    fullUrl += searchModel.acoAlliance ? `&acoAlliance=${searchModel.acoAlliance}` : "";
    fullUrl += searchModel.practiceGroup ? `&practiceGroup=${searchModel.practiceGroup}` : "";
    fullUrl += searchModel.groupByCarrier ? `&groupByCarrier=${ searchModel.groupByCarrier }` : "";

    const params = {
        headers: {
            "x-bsw-clientid": CLIENT_ID,
            "accept": "application/json"
        },
        method: "GET"
    };
    
    var start = new Date();
    return fetch(fullUrl, params)
        .then(response => {
            return response.json();
        })
        .then(json => {
            return { timestamp: timestamp, results: json };
        })
        .catch(err => { logAPI("MBHWeb.Api.Typeahead.MatchingInsurance.Failure", new Date(), fullUrl, err); return Promise.reject(err); });
};
